import { render, staticRenderFns } from "./campaignGeneralForm.vue?vue&type=template&id=74877d42&scoped=true&"
import script from "./campaignGeneralForm.vue?vue&type=script&lang=js&"
export * from "./campaignGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./campaignGeneralForm.vue?vue&type=style&index=0&id=74877d42&prod&lang=scss&"
import style1 from "./campaignGeneralForm.vue?vue&type=style&index=1&id=74877d42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74877d42",
  null
  
)

export default component.exports